import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { reduxForm, Field } from 'redux-form';
import { Grid } from './../../../themes/default';
import { Section, Content, Main, Buttons, FormContent, FormActions } from './../../../components/includes/container';
import { Loading } from './../../../components/includes/loading';
import { ToolbarPrimary } from './../../../components/includes/toolbar';
import { BreadcrumbItem } from './../../../components/includes/breadcrumb';
import { Ttolbar } from './../../../components/includes/ui/table';
import { InputTextField, SelectField, OptionField } from './../../../components/includes/ui/input';
import { Btn, RichTextMarkdown } from './../../../components/includes/ui';
import { PollService } from './../../../services';

import VALIDATION from './../../../config/validation';

const validate = values => {

  const errors = {}

  if (values.status === '-1') {
    errors.status = VALIDATION.required;
  }

  if (values.days < 0) {
    errors.days = 'El número debe ser mayor o igual a 1';
  }

  if (!values.name) {
    errors.name = VALIDATION.required;
  }else if(values.name.length > 255){
    errors.name = 'El tamaño máximo es de 255 caracteres.';
  }

  if (!values.text) {
    errors.text = VALIDATION.required;
  }else if(values.text.length > 255){
    errors.text = 'El tamaño máximo es de 255 caracteres.';
  }

  return errors

};

class PollUpdate extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      id: null,
      loading: false,
      sending: false
    };
  }

  componentDidMount(){

    this._Find(this.props.match.params.id);

  }

  /*
  ** @Service
  ** @Description: Find
  */

  _Find = (id) => {

    PollService.find(id).then((response) => {

      // @State
      this.setState({ loading: true, id: id });

      // @Dispatch
      this.props.Update(response);

    }).catch((error) => {

      // @Dispatch alert error
      this.props.AlertShow({ open: true, variant: 'error', message: error });

    });

  }

  /*
  ** @Service
  ** @Description: Update
  */

  _Update = (values) => {

    // @Loading
    this.setState({ loading: false });

    // @Service
    PollService.update(this.state.id, values).then((response) => {

      /**
      * @Service find all by page
      */
      this.props.history.push('/polls');

      /**
      * @Dispatch for alert success message
      */
      this.props.AlertShow({ open: true, variant: 'success', message: `Éxito, la encuesta fue editada.` });

    }).catch((error) => {

      // @Dispatch alert error
      this.props.AlertShow({ open: true, variant: 'error', message: error.data.message });

    });

  }

  /*
  ** @Event
  ** @Description: Submit button
  */

  handleSubmitForm = (values) => {
    this._Update(values);
  }

  render() {

    const { loading, sending } = this.state;
    const { handleSubmit, invalid } = this.props;

    return (
      <Section>
        <ToolbarPrimary title="Encuestas"/>
        <BreadcrumbItem to='/polls'>Encuestas</BreadcrumbItem>
        <BreadcrumbItem to='/polls/update'>Editar</BreadcrumbItem>
        <Content>

          <Main>

            { loading ? (

              <form noValidate autoComplete="off" onSubmit={ handleSubmit(this.handleSubmitForm) }>

                <Ttolbar title="Edición de encuesta"/>

                <FormContent enabledActions>

                  <Grid container spacing={24}>

                    <Grid item lg={4} md={4} sm={12} xs={12}>
                      <Field
                          name="name"
                          component={ InputTextField }
                          label="Nombre"
                          type="text"
                          required
                      />
                    </Grid>

                    <Grid item lg={4} md={4} sm={12} xs={12}>
                      <Field
                          name="days"
                          component={ InputTextField }
                          label="Días"
                          type="number"
                          required
                      />
                    </Grid>

                    <Grid item lg={4} md={4} sm={12} xs={12}>
                      <Field
                          name="status"
                          component={ SelectField }
                          label="Estado" required>
                            <OptionField key="-1" value="-1">Seleccionar...</OptionField>
                            <OptionField key="true" value="true">Activo</OptionField>
                            <OptionField key="false" value="false">Bloqueado</OptionField>
                      </Field>
                    </Grid>

                    <Grid item lg={4} md={4} sm={12} xs={12}>
                      <Field
                          name="template_mktc"
                          component={ InputTextField }
                          label="Template"
                          type="text"
                          required
                      />
                    </Grid>

                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Field
                          name="text"
                          component={ InputTextField }
                          label="Título"
                          type="text"
                          required
                      />
                    </Grid>

                    <Grid item lg={12} md={12} sm={12}>
                      <Field
                          name="thanks"
                          component={ RichTextMarkdown }
                          label="Final"
                          type="text"
                          required={true}
                      />
                    </Grid>

                  </Grid>

                </FormContent>

                <FormActions>
                  <Grid container>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                      <Buttons>
                        <Btn aria-label="Volver" icon="back" color="secondary" component={ NavLink } to="/polls">
                          Volver
                        </Btn>
                      </Buttons>
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                      <Buttons align="right">
                        <Btn aria-label="Guardar" icon="add" color="success" type="submit" disabled={ invalid } loading={ sending }>
                          Guardar
                        </Btn>
                      </Buttons>
                    </Grid>
                  </Grid>
                </FormActions>

              </form>

            ) : (
              <Loading variant="primary"/>
            )}

          </Main>

        </Content>
      </Section>
    )
  }
}

PollUpdate = reduxForm({
  form: 'PollUpdate',
  validate,
  enableReinitialize: true
})(PollUpdate);

const mapStateToProps = (state) => {
  return {
    Alert: state.Alert,
    PollUpdate: state.PollUpdate
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    AlertShow: (data) => {
      dispatch({
        type: 'ALERT_SHOW',
        data: data
      });
    },
    Update: (data) => {
      dispatch({
        type: 'POLL_UPDATE',
        data: data
      });
    }
  }
}

PollUpdate = connect(
  state => ({
    initialValues: {
      name: state.PollUpdate.name,
      status: state.PollUpdate.status,
      days: state.PollUpdate.days,
      text: state.PollUpdate.text,
      thanks: state.PollUpdate.thanks
    }
  })
)(PollUpdate);

export default connect(mapStateToProps, mapDispatchToProps)(PollUpdate);
